import React from 'react';
import { connect } from 'react-redux';
import WhatIfResultsComparePres from '../presentational/WhatIfResultsComparePres';
import { setPageType } from '../state/whatIfActions';
import intl from 'react-intl-universal';
import Typography from '@material-ui/core/Typography';
import CurrencyFormat from 'react-currency-format';

const mod = (x, n) => ((x % n) + n) % n;

class WhatIfResultsCompareContainer extends React.Component {
  state = {
    selectedResults: this.props.results
      .filter(result => {
        return result.selected;
      })
      .map((result, index) => {
        result.id = index;
        result.type = 'Employee Type ' + ++index;
        return result;
      }),
    graphData: [],
    graphSelected: null,
  };

  componentDidMount() {
    this.setState({
      graphData: this.getGraphData(),
      numEmployees: this.getNumEmployees(),
      headerTitle: this.getHeaderTitle(),
    });
  }

  getHeaderTitle() {
    const results = this.state.selectedResults;
    let numEmployees = 0;
    let totalCost = 0;

    let currency = 'USD';
    results.forEach(result => {
      numEmployees += result.numEmployees;
      totalCost += result.totalCompensation * result.numEmployees;
      currency = result.outputCurrency;
    });

    return (
      <Typography variant="title" style={{ fontFamily: "'EYInterstate Light', sans-serif" }}>
        Total assignment cost for <b>{numEmployees} employees </b> is{' '}
        <b>
          {
            <CurrencyFormat
              value={totalCost}
              displayType={'text'}
              decimalScale={2}
              thousandSeparator={true}
              prefix={intl.get('whatif.calculator.currency.prefix')[currency]}
              suffix={intl.get('whatif.calculator.currency.suffix')[currency]}
            />
          }
        </b>
      </Typography>
    );
  }

  getNumEmployees() {
    let numEmployees = 0;

    this.state.selectedResults.forEach(result => {
      numEmployees += result.numEmployees;
    });

    return numEmployees;
  }

  getGraphData = () => {
    let data = [];
    this.state.selectedResults.forEach(result => {
      if (result.selected) {
        data.push({
          result: result,
          label: result.classification,
          theta: result.totalCompensationWithEmployees,
          radius: 70,
          innerRadius: 55,
          opacity: 0.8,
          color: this.props.colors[mod(result.id, this.props.colors.length)],
        });
      }
    });

    this.setState({
      graphSelected: data[0],
    });

    data[0].radius = 75;
    data[0].innerRadius = 53;
    data[0].opacity = 1;

    return data;
  };

  onAddEmployees = () => {
    this.props.setPageType('list');
  };

  onMouseOver = value => {
    let graphData = this.state.graphData;
    graphData.forEach(result => {
      if (value.result.id === result.result.id) {
        result.opacity = 1;
      } else {
        result.opacity = 0.8;
      }
    });

    this.setState({
      graphData: graphData,
    });
  };

  onLeftChevron = () => {
    let index = mod(this.state.graphSelected.result.id - 1, this.state.selectedResults.length);
    let graphSelected = this.state.graphData[index];

    this.onMouseClick(graphSelected);

    this.setState({
      graphSelected: graphSelected,
    });
  };

  onRightChevron = () => {
    let index = mod(this.state.graphSelected.result.id + 1, this.state.selectedResults.length);
    let graphSelected = this.state.graphData[index];

    this.onMouseClick(graphSelected);

    this.setState({
      graphSelected: graphSelected,
    });
  };

  onMouseClick = value => {
    let { graphData } = this.state;

    graphData.forEach(result => {
      if (value.result.id === result.result.id) {
        result.radius = 75;
        result.innerRadius = 53;
        // if(graphSelected && graphSelected.result.id === result.result.id) {
        //   result.radius = 70;
        //   result.innerRadius = 55;
        //   this.setState({
        //     graphSelected: null
        //   });
        // }
        // else {
        //   this.setState({
        //     graphSelected: result
        //   });
        // }
        this.setState({
          graphSelected: result,
        });
      } else {
        result.radius = 70;
        result.innerRadius = 55;
      }
    });

    this.setState({
      graphData: graphData,
    });
  };

  onMouseOut = () => {
    let graphData = this.state.graphData;
    graphData.forEach(result => {
      result.opacity = 0.8;
    });

    this.setState({
      graphData: graphData,
    });
  };

  render() {
    return (
      <WhatIfResultsComparePres
        {...this.props}
        {...this.state}
        getGraphData={this.getGraphData}
        onAddEmployees={this.onAddEmployees}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onMouseClick={this.onMouseClick}
        onMouseLeave={this.onMouseLeave}
        onLeftChevron={this.onLeftChevron}
        onRightChevron={this.onRightChevron}
      />
    );
  }
}

const mapStateToProps = state => ({
  colors: state.whatIf.colors,
});

const mapDispatchToProps = {
  setPageType,
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfResultsCompareContainer);
